var _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 618,
    viewBox: "0 0 646 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 25,
    width: 156,
    height: 39,
    rx: 2,
    fill: "#EA305C",
    fillOpacity: 0.34,
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -125,
    y: 630,
    width: 156,
    height: 39,
    rx: 2,
    fill: "#A71437",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "multiply"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 12,
    width: 186,
    height: 33,
    rx: 2,
    fill: "#EA305C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -141,
    y: 267,
    width: 186,
    height: 33,
    rx: 2,
    fill: "#EA305C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 481,
    y: 555,
    width: 158,
    height: 16,
    rx: 2,
    fill: "#EA305C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 386,
    y: 0,
    width: 206,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: -150,
    y: 605,
    width: 206,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBg);
export default __webpack_public_path__ + "static/media/welcome-bg.628436cc519f6b71fd8408c6e27ff39f.svg";
export { ForwardRef as ReactComponent };